var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          _c("v-chart", {
            staticClass: "price-chart",
            attrs: {
              options: _vm.option,
              "init-options": _vm.initOptions,
              theme: "ovilia-green",
              autoresize: ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "align-center": "" } },
        [
          _c(
            "v-flex",
            { attrs: { "offset-xs1": "" } },
            [
              _c("v-checkbox", {
                attrs: { label: _vm.$t("splitLine") },
                model: {
                  value: _vm.splitLineToggle,
                  callback: function($$v) {
                    _vm.splitLineToggle = $$v
                  },
                  expression: "splitLineToggle"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("p", [_vm._v("* " + _vm._s(_vm.$t("chartDataTips")))]),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs1: "" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53877b1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53877b1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductStatistics.vue
// module id = null
// module chunks = 